import React, { useState } from 'react';
import { wordsToIpa } from '../../transcribe/wordsToIpa';
import { Say } from '../widgets/Say';

/**
 * UI for looking up the pronunciation of words in the US and UK dictionaries
 */
export function DictionaryLookup() {
  const [word, setWord] = useState('');
  const [pronounceUS, setPronounceUS] = useState('');
  const [pronounceUK, setPronounceUK] = useState('');

  function onKey(s: string) {
    if (s === 'Enter') {
      lookup();
    }
  }

  function lookup() {
    const [us] = wordsToIpa(word);
    setPronounceUS(us.length > 0 ? `/${us}/` : '?');
    const [uk] = wordsToIpa(word, 'en_UK');
    setPronounceUK(uk.length > 0 ? `/${uk}/` : '?');
  }

  return (<>
    <input size={20} value={word} maxLength={40}
      onChange={(e) => setWord(e.target.value)} onKeyPress={(e) => onKey(e.key)} />
    &nbsp;&nbsp;

    <button onClick={() => lookup()} disabled={word.length === 0}>lookup</button>
    &nbsp;&nbsp;&nbsp;&nbsp;

    US: {pronounceUS.length === 0 ? '' : pronounceUS === '?' ? <i>not present</i> : <Say>{pronounceUS}</Say>}
    &nbsp;&nbsp;&nbsp;&nbsp;
    UK: {pronounceUK.length === 0 ? '' : pronounceUK === '?' ? <i>not present</i> : <Say>{pronounceUK}</Say>}
  </>);
}
